(() => {
  const TZ = 'Africa/Casablanca';
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const parts = (date) => Object.fromEntries(
    formatter.formatToParts(date).filter((part) => part.type !== 'literal')
      .map((part) => [part.type, Number(part.value)])
  );
  const casablancaTarget = (date, hour, minute) => {
    const p = parts(date);
    const guess = Date.UTC(p.year, p.month - 1, p.day, hour, minute, 0);
    const local = parts(new Date(guess));
    const offset = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second) - guess;
    return new Date(guess - offset);
  };
  const nextDailyCutoff = (now, hour, minute) => {
    let target = casablancaTarget(now, hour, minute);
    if (target <= now) target = casablancaTarget(new Date(now.getTime() + 86400000), hour, minute);
    return target;
  };
  const initCountdown = (root) => {
    if (root.dataset.yakootaCountdownBound) return;
    root.dataset.yakootaCountdownBound = 'true';
    const mode = root.dataset.mode || 'daily_cutoff';
    const fields = {
      days: root.querySelector('[data-countdown-days] b'),
      hours: root.querySelector('[data-countdown-hours] b'),
      minutes: root.querySelector('[data-countdown-minutes] b'),
      seconds: root.querySelector('[data-countdown-seconds] b')
    };
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
    let interval;
    const render = () => {
      const now = new Date();
      let target;
      if (mode === 'fixed_date' || mode === 'dispatch_deadline') {
        target = new Date(root.dataset.fixedEnd || '');
        if (Number.isNaN(target.getTime())) { root.hidden = true; return; }
      } else {
        target = nextDailyCutoff(now, Number(root.dataset.cutoffHour || 0), Number(root.dataset.cutoffMinute || 0));
      }
      let remaining = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
      if (remaining <= 0 && mode !== 'daily_cutoff') {
        root.hidden = true;
        if (interval) clearInterval(interval);
        return;
      }
      const days = Math.floor(remaining / 86400);
      remaining %= 86400;
      const hours = Math.floor(remaining / 3600);
      remaining %= 3600;
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;
      if (fields.days) fields.days.textContent = pad(days);
      if (fields.hours) fields.hours.textContent = pad(hours);
      if (fields.minutes) fields.minutes.textContent = pad(minutes);
      if (fields.seconds) fields.seconds.textContent = pad(seconds);
      root.classList.toggle('yakoota-countdown--short', days === 0);
      root.hidden = false;
    };
    render();
    interval = window.setInterval(render, 1000);
    root.addEventListener('shopify:section:unload', () => { if (interval) clearInterval(interval); }, { once: true });
  };
  const init = (scope = document) => scope.querySelectorAll('[data-yakoota-countdown]').forEach(initCountdown);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();